import { seriesSvgMulti } from '@d3fc/d3fc-series';
import { boundaryLines } from 'widgets/signalTiles/pfeTile/components/chart/series/boundaryLines';
import { valueLine } from 'widgets/signalTiles/pfeTile/components/chart/series/lineSeries';

export const getPfeTileSeries = (
    lowerBoundary: number,
    upperBoundary: number
) =>
    seriesSvgMulti().series([
        valueLine,
        ...boundaryLines(lowerBoundary, upperBoundary),
    ]);
